import React, { useState } from "react";
import {
  FormControl,
  Grid,
  IconButton,
  TextField,
  Checkbox,
  Box,
} from "@mui/material";
import Select from "react-select";
import CloseIcon from "@mui/icons-material/Close";

const daysOptions = [
  { value: "Monday", label: "Monday" },
  { value: "Tuesday", label: "Tuesday" },
  { value: "Wednesday", label: "Wednesday" },
  { value: "Thursday", label: "Thursday" },
  { value: "Friday", label: "Friday" },
  { value: "Saturday", label: "Saturday" },
  { value: "Sunday", label: "Sunday" },
];

const timeRegex = /^(0?[1-9]|1[0-2]):[0-5][0-9] (AM|PM)$/;

interface Timing {
  day: string;
  startTime: string;
  endTime: string;
  other?: string;
  others?: string;
}

interface TimingSelectProps {
  timings: Timing[];
  onTimingChange: (index: number, field: keyof Timing, value: string) => void;
  onRemove: (index: number) => void;
  availableDays: string[];
  index: number;
  other?: boolean;
  isBusiness?: boolean;
}

const TimingSelect: React.FC<TimingSelectProps> = ({
  timings,
  onTimingChange,
  onRemove,
  availableDays,
  index,
  other,
  isBusiness = false,
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [errors, setErrors] = useState({ startTime: "", endTime: "" });

  const handleTimeChange = (field: any, value: any) => {
    if (!timeRegex.test(value)) {
      setErrors((prev) => ({
        ...prev,
        [field]: field === "startTime" ? "Eg. 09:00 AM or 9:00 AM" : "Eg. 06:00 PM or 6:00 PM",
      }));
    } else {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
    onTimingChange(index, field, value);
  };


  return (
    <Grid container spacing={2} sx={{ display: "flex", alignItems: "center" }}>
      <Grid item xs={12} sm={4}>
        <FormControl fullWidth>
          <Select
            value={daysOptions.find(
              (option) =>
                option.value.toLowerCase() === timings[index].day.toLowerCase()
            )}
            options={daysOptions.filter(
              (option) =>
                !availableDays.some(
                  (day) => day.toLowerCase() === option.value.toLowerCase()
                ) || option.value === timings[index].day
            )}
            onChange={(selectedOption) =>
              onTimingChange(index, "day", selectedOption?.value ?? "")
            }
            placeholder="Select day"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={2}>
        <TextField
          label="Start Time"
          name="startTime"
          value={timings[index].startTime}
          onChange={(e) => handleTimeChange("startTime", e.target.value)}
          placeholder="Enter Start Time"
          fullWidth
          variant="outlined"
          error={!!errors.startTime}
          helperText={errors.startTime}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <TextField
          label="End Time"
          name="endTime"
          value={timings[index].endTime}
          onChange={(e) => handleTimeChange("endTime", e.target.value)}
          placeholder="Enter End Time"
          fullWidth
          variant="outlined"
          error={!!errors.endTime}
          helperText={errors.endTime}
        />
      </Grid>
      {
        <Grid item xs={12} sm={3} display={"flex"}>
          <TextField
            label="Other"
            name="other"
            value={isBusiness ? timings[index].others : timings[index].other}
            onChange={(e) =>
              onTimingChange(
                index,
                `${isBusiness ? "others" : "other"}`,
                e.target.value
              )
            }
            placeholder="Other values"
            fullWidth
            variant="outlined"
          />
          <Checkbox
            checked={isChecked}

            onChange={() => {
              setIsChecked(!isChecked);
              onTimingChange(
                index,
                `${isBusiness ? "others" : "other"}`,
                !isChecked ? "24 Hour Open" : ""
              );
            }}
          />
          <Box>24 Hours Open</Box>
        </Grid>
      }
      <Grid item xs={12} sm={1}>
        <IconButton aria-label="delete" onClick={() => onRemove(index)}>
          <CloseIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default TimingSelect;